import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';

import { GET_APPLICANT_BY_ID } from './get-applicant-by-id.hook';
import { GET_APPLICANTS_BY_VACANCY } from './get-applicants-by-vacancy.hook';

export const UPDATE_APPLICANT_BY_ID = gql`
  mutation updateApplicant($payload: UpdateApplicantInput!, $applicantId: ObjectId!) {
    updateApplicant(payload: $payload, applicantId: $applicantId) {
      _id
    }
  }
`;

export const useUpdateApplicantById = ({ onSuccess }: Partial<IHookCallbacks>) => {
  const { t } = useTranslation('vacancies');
  const [updateApplicant, { loading }] = useMutation(UPDATE_APPLICANT_BY_ID, {
    refetchQueries: [GET_APPLICANTS_BY_VACANCY, GET_APPLICANT_BY_ID],
    onCompleted: () => {
      if (onSuccess) {
        return onSuccess();
      }

      showNotification({
        type: NOTIFICATION_TYPE.success,
        message: t('notifications.statusChanged'),
      });
    },
  });

  return { updateApplicant, loading };
};
